import React from 'react';
import Paginations from '../common/paginations';
import constant from '../../constant';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment';
import DetailModal from './detailModal'
import AdminDeleteButton from '../common/AdminDeleteButton';
const AppraisalSubmittedList = ({ data, setCurrentPage, limit }) => {
    const { appraisals, pagination } = data;
    const { total, page } = pagination;
    console.log(appraisals)
    return (
        <React.Fragment>
            <div className="table-responsive">
                <table className="table align-middle table-hover">
                    <thead className="table-light">
                        <tr>
                            <th>#</th>
                            <th>Employee Information</th>
                            <th>Site Location</th>
                            <th>Submitted On</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {appraisals?.length > 0 ? (
                            appraisals.map((item, index) => (
                                <React.Fragment key={index}>
                                    <tr>
                                        <td style={{ fontSize: 15, fontFamily: "nunito" }}>{(page - 1) * limit + index + 1}</td>
                                        <td>{item.FULL_NAME}

                                            <p ><span style={{ color: "#ab5858" }}>{item.DESIGNATION_NAME}</span>

</p>
                                        </td>
                                        <td>
                                            {item.SITE_LOCATION_NAME}{" "}
                                        </td>
                                        <td>
                                            {moment(item.CREATED_ON).format('DD MMM YYYY')}
                                        </td>
                                        <td>
                                            <p className="text-muted mb-0">
                                                Site Manager :{" "}
                                                {item.SITE_MANAGER_SIGNATURE ?
                                                    <span style={{ color: "rgb(7, 112, 42)" }}>Completed</span>
                                                    :
                                                    <span style={{ color: "#ab5858" }}>Pending</span>
                                                }
                                            </p>
                                            <p className="text-muted mb-0">
                                                Project Manager :{" "}
                                                {item.PROJECT_MANAGER_SIGNATURE ?
                                                    <span style={{ color: "rgb(7, 112, 42)" }}>Completed</span>
                                                    :
                                                    <span style={{ color: "#ab5858" }}>Pending</span>
                                                }
                                            </p>
                                            <p className="text-muted mb-0">
                                                Office Incharge :{" "}
                                                {item.OFFICE_INCHARGE_SIGNATURE ?
                                                    <span style={{ color: "rgb(7, 112, 42)" }}>Completed</span>
                                                    :
                                                    <span style={{ color: "#ab5858" }}>Pending</span>
                                                }
                                            </p>
                                            <p className="text-muted mb-0">
                                                Appraiser :{" "}
                                                {item.APPRAISER_SIGNATURE ?
                                                    <span style={{ color: "rgb(7, 112, 42)" }}>Completed</span>
                                                    :
                                                    <span style={{ color: "#ab5858" }}>Pending</span>
                                                }
                                            </p>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-20 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href="javascript:void(0);"
                                                        title="View Appraisal"
                                                        data-bs-toggle="modal"
                                                        data-bs-target={`#appraisalModal-${item.ID}`}
                                                    >
                                                        <i className="bx bxs-zoom-in" />
                                                    </a>
                                                </li>

                                            </ul>
                                            <AdminDeleteButton resource="appraisal" entryId={item.ID} label="appraisal" />
                                        </td>
                                    </tr>


                                    {/* Modal */}
                                    <div
                                        className="modal fade"
                                        id={`appraisalModal-${item.ID}`}
                                        data-bs-backdrop="static"
                                        data-bs-keyboard="false"
                                        tabIndex={-1}
                                        role="dialog"
                                        aria-labelledby="appraisalModalLabel"
                                        aria-hidden="true"
                                    >
                                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title" id="appraisalModalLabel">
                                                        Appraisal Details
                                                    </h5>
                                                    <button
                                                        type="button"
                                                        className="btn-close"
                                                        data-bs-dismiss="modal"
                                                        aria-label="Close"
                                                    />
                                                </div>
                                                <div className="modal-body">
                                                    <  DetailModal
                                                        data={item}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" className="text-center text-muted">No appraisal submissions found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Paginations
                range={5}
                limit={limit}
                totalCount={total}
                currentPage={page}
                onPageChange={setCurrentPage}
            />
        </React.Fragment>
    );
};

export default AppraisalSubmittedList;
